import Toast from 'components/Toast/Manager.vue';
import IntegrationsMixin from 'mixins/integrations';

export default {
    mixins: [IntegrationsMixin],

    components: {
        Toast,
    },

    computed: {},
};
